import { useEffect, useState } from "react";
import { fetchLTRemnantData } from "../../../api/homeApi";
import { toast } from "react-toastify";



function useLTRemanentLife(filter, currentDateISO, maxExpiryDateISO) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!filter) return; // avoid unnecessary calls if filter is empty

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchLTRemnantData(filter, currentDateISO, maxExpiryDateISO);
        setData(response); // assuming response has a `data` field
      } catch (err) {
        toast.error("Cannot fetch CMLs with Shortest Remnent Life");
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [JSON.stringify(filter, currentDateISO, maxExpiryDateISO)]);
  return { data, loading, error };
}

export default useLTRemanentLife;